import React, { Component } from 'react';
import $ from "jquery"
import './Team.css'


class Team extends Component {
    render() {
        
        function checkViewPort() {
            var check;
            var top_of_element = $(".underline-level3").offset().top;
            var bottom_of_element = $(".underline-level3").offset().top + $(".underline-level3").outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();
        
            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
                check=true;
            } else {
                check=false;
            }
            return check;
        }
    
        $(function () {
            var element = $(".underline-level3");
            $(window).on('scroll', function () {
                if(checkViewPort()) {
                    element.addClass("animateMe");
                }
            });
        });

        return(
            <div>
              <div className='mx-3 text-center'>
                <div className='underline-level3'></div>
                <h1 className="text-mint lato-light">Team</h1>
                <p className='py-3'>Once upon a long time ago there are family of panda going through the jungle discovered an album of pandas</p>
              </div>
            </div>
        );
    }
}

export default Team;
